import "core-js/modules/es6.regexp.replace";
export default function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}